<template>
  <div class="d-flex flex-column h-100">
    <div class="text-center d-none d-sm-block pb-2">
      <img src="../../assets/images/home/logoWhite.svg" class="imgLogo" @click="$router.push({name: 'Home'})" :title="$t('general.slogan')" :alt="$t('general.slogan')" />
    </div>

    <p class="descriptionBar text-right"><slot name="header"/></p>

    <div class="content" v-if="contentID">
      <p class="textAcent pt-2">VENEZUELA</p>

      <div class="pt-2">
        <div class="row my-2 flex-column-reverse align-items-center flex-xl-row">
          <div class="col-9 p-0">
            <p class="text text-center pt-2">Puerto Ordaz - Bolívar </p>
          </div>
          <div class="col-2 mb-2 mb-xl-0">
            <img alt="placeholder" src="../../assets/images/contact/placeholder.png"/>
          </div>
        </div>

        <div class="row my-5 flex-column-reverse align-items-center flex-xl-row">
          <div class="col-9 p-0 text text-center">
            <a href="https://api.whatsapp.com/send?phone=+584128750347" target="_blank" class="d-block w-100 ws-link">+58 412 8750347</a>
<!--            <span class="d-block w-100">+58 286 - 961.58.99</span>-->
<!--            <span class="d-block w-100">+58 286 - 961.32.85</span>-->
<!--            <span class="d-block w-100 ">+58 286 - 971.95.09</span>-->
          </div>
          <div class="col-2 icon mb-2 mb-xl-0">
            <img alt="telephone" class="mt-3" src="../../assets/images/contact/oldTelephone.png"/>
          </div>

        </div>

        <div class="row my-2 flex-column-reverse align-items-center flex-xl-row">
          <div class="col-9 p-0 text-center">
            <a href="mailto:info@grupoapok.com"  target="_blank" class="text text-center mb-0 to-email">info@grupoapok.com</a>
          </div>
          <div class="col-2 mb-2 mb-xl-0">
            <img alt="mail" src="../../assets/images/contact/mailBlackEnvelopeSymbol.png"/>
          </div>

        </div>

      </div>

    </div>

    <div class="footerDiv mt-auto">
      <p class="descriptionBar text-right bot"><slot name="footer"/></p>
      <a href="https://blog.grupoapok.com" target="_blank" class="descriptionBar d-block  text-right bot text-uppercase">
        {{ 'blog.content.message' | translate }}
      </a>
      <social-icons/>
    </div>

  </div>
</template>

<script>
  import SocialIcons from '../SocialIcons'

  export default {
    name: 'Content',
    components: {SocialIcons},
    data () {
      return {}
    },
    props: {
      contentID: {
        type: Boolean,
        default: false
      }
    },
    computed: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

  .ws-link, .to-email {
    color: #fff;
    position: relative;

    &:after {
      /*content: "";*/
      background-color: #fff;
      height: 1px;
      width: 30px;
      position: absolute;
      bottom: -3px;
      left: 50%;
      transform: translateX(-50%);

    }
    &:hover {
      cursor: pointer;
      color: #1D8DA1;
      text-decoration: none;
      text-shadow: none;
      font-weight: 700;

      &:after {
        background-color: #1D8DA1;
      }

    }
  }

  .descriptionBar{
    font-family: "Open Sans", sans-serif;
    color: #FFFFFF;
    font-size: 0.9rem;

    @media (min-width: 1400px) {
      font-size: 1rem;
    }
  }

  .imgLogo{
    cursor: pointer;
    top: 2rem;
    width: 70%;
  }

  .bot{
    text-shadow: 2px 2px 2px #252424a3;
  }

  .text {
    text-shadow: 2px 2px 2px #252424a3;
    font-family: "Open Sans", sans-serif;
    color: #FFFFFF;
    font-size: 1rem;
    //line-height: 4px;
  }

  .textAcent {
    text-shadow: 2px 2px 2px #252424a3;
    font-family: "Open Sans", sans-serif;
    font-weight: 800;;
    color: #FFFFFF;
    font-size: 1rem;
    text-align: center;
  }

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1400px) {
    .content {
      margin-top: 50%;
    }

    .text {
      font-size: 1.1rem;
    }

    .textAcent {
      font-size: 1.1rem;;
    }

  }

  .icon {
    margin-top: -17px;
    align-self: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/contentBar/barContact.vue